import { useCallback } from 'react';
import { prop } from 'ramda';
import { useNavigate } from 'js/hooks/navigate';
import { useAppSelector } from 'js/store/hooks';
import { useLoginPopup } from 'js/components/popups/LoginPopup';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

export const useOnLoginButtonClick = () => {
    const navigate = useNavigate();
    const showLoginPopup = useLoginPopup();
    const closePopups = useSmartClosePopups();
    const loginPage = useAppSelector(prop('loginPage'));

    return useCallback((): void => {
        const separator = loginPage && loginPage.indexOf('?') === -1 ? '?' : '&';

        if (loginPage) {
            closePopups();
            navigate(`${loginPage}${separator}afterLoginUrl=${encodeURIComponent(window.location.pathname)}`);
        } else {
            showLoginPopup();
        }
    }, [loginPage, navigate, showLoginPopup, closePopups]);
};
